import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toPlainText'
})
export class ToPlainTextPipe implements PipeTransform {
  transform (value = '', length = 500) {
    const text = value && value.replace(/<[^>]*>/g, '').replace(/&nbsp;/gi, ' ') || '';
    return text.length > length ? text.substring(0, length) + ' ...' : text;
  }
}
